// src/components/settings/TabFinance.jsx

import React from 'react';
import {
    FaWeight,
    FaWallet,
    FaUniversity,
    FaMoneyBillWave,
    FaInfoCircle,
    FaUsers
} from 'react-icons/fa';

const TabFinance = ({
    config,
    handleNestedChange,
    handlePriceChange,
    handleChange,
    formatCurrency
}) => {
    const bankInfo = config?.bank_info || {
        bank_name: '',
        account_number: '',
        account_holder: ''
    };

    const prices = config?.prices || {
        team_registration: 0,
        kyorugi: 0,
        poomsae_individual: 0,
        poomsae_freestyle: 0,
        poomsae_pair: 0,
        poomsae_team: 0
    };

    const priceFields = [
        {
            key: 'team_registration',
            label: 'Pendaftaran Kontingen',
            description: 'Biaya tetap satu kali untuk setiap kontingen/tim.',
            featured: true
        },
        {
            key: 'kyorugi',
            label: 'Kyorugi',
            description: 'Biaya untuk setiap entry atlet Kyorugi.'
        },
        {
            key: 'poomsae_individual',
            label: 'Poomsae Individual',
            description: 'Biaya untuk satu entry Poomsae perorangan.'
        },
        {
            key: 'poomsae_freestyle',
            label: 'Poomsae Freestyle',
            description: 'Biaya untuk satu entry Poomsae Freestyle.'
        },
        {
            key: 'poomsae_pair',
            label: 'Poomsae Pair',
            description: 'Biaya satu entry Pair, bukan per nama atlet.'
        },
        {
            key: 'poomsae_team',
            label: 'Poomsae Team',
            description: 'Biaya satu entry Team, bukan per nama atlet.'
        }
    ];

    return (
        <div
            className="card border-0 shadow-sm animate-fade-in"
            style={{
                background: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px'
            }}
        >
            <div className="card-body p-4">
                <div className="d-flex align-items-center gap-2 mb-4">
                    <div className="bg-primary bg-opacity-10 text-primary rounded-3 p-2">
                        <FaWallet />
                    </div>
                    <div>
                        <h5 className="fw-bold text-primary mb-0">Biaya & Rekening</h5>
                        <p className="text-muted small mb-0">
                            Atur biaya pendaftaran kontingen, biaya lomba, rekening pembayaran, dan aturan penimbangan.
                        </p>
                    </div>
                </div>

                {/* INFO BANK */}
                <div className="d-flex align-items-center gap-2 mb-3">
                    <FaUniversity className="text-muted" />
                    <h6 className="fw-bold text-dark mb-0">Informasi Rekening Transfer</h6>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-md-4">
                        <label className="form-label small fw-bold text-muted">Nama Bank</label>
                        <input
                            type="text"
                            className="form-control"
                            value={bankInfo.bank_name || ''}
                            onChange={(e) => handleNestedChange('bank_info', 'bank_name', e.target.value)}
                            placeholder="Contoh: BCA"
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label small fw-bold text-muted">Nomor Rekening</label>
                        <input
                            type="text"
                            className="form-control"
                            value={bankInfo.account_number || ''}
                            onChange={(e) => handleNestedChange('bank_info', 'account_number', e.target.value)}
                            placeholder="Contoh: 1234567890"
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label small fw-bold text-muted">Atas Nama</label>
                        <input
                            type="text"
                            className="form-control"
                            value={bankInfo.account_holder || ''}
                            onChange={(e) => handleNestedChange('bank_info', 'account_holder', e.target.value)}
                            placeholder="Nama pemilik rekening"
                        />
                    </div>
                </div>

                <hr className="text-muted opacity-25" />

                {/* HARGA */}
                <div className="d-flex align-items-center gap-2 mb-3">
                    <FaMoneyBillWave className="text-muted" />
                    <h6 className="fw-bold text-dark mb-0">Nominal Pendaftaran (Rp)</h6>
                </div>

                <div className="alert alert-info border-0 bg-info bg-opacity-10 small rounded-3 d-flex gap-2 mb-4">
                    <FaInfoCircle className="mt-1 flex-shrink-0" />
                    <div>
                        <strong>Catatan:</strong> Biaya pendaftaran kontingen dihitung <b>satu kali per tim</b>.
                        Biaya Kyorugi dan Poomsae tetap dihitung per entry. Poomsae Pair dan Team dihitung sebagai
                        <b> satu entry</b>, bukan dikalikan jumlah nama atlet.
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    {priceFields.map((field) => (
                        <div className={field.featured ? 'col-12' : 'col-md-6'} key={field.key}>
                            <div
                                className={field.featured ? 'p-3 rounded-4 border bg-primary bg-opacity-10' : ''}
                            >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                    {field.featured && <FaUsers className="text-primary" />}
                                    <label className="form-label small fw-bold text-muted mb-0">
                                        {field.label}
                                    </label>
                                </div>

                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">Rp</span>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control border-start-0 ps-0 fw-bold text-dark"
                                        value={formatCurrency(prices[field.key] || 0)}
                                        onChange={(e) => handlePriceChange(field.key, e.target.value)}
                                        placeholder="0"
                                    />
                                </div>

                                <div className="form-text">{field.description}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <hr className="text-muted opacity-25" />

                {/* ATURAN BERAT */}
                <h6 className="fw-bold text-dark mb-3">Aturan Pertandingan</h6>

                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label small fw-bold text-muted">
                            <FaWeight className="me-1" /> Toleransi Berat Badan (Kg)
                        </label>
                        <input
                            type="number"
                            step="0.1"
                            className="form-control"
                            name="weight_tolerance"
                            value={config?.weight_tolerance ?? 0.5}
                            onChange={handleChange}
                        />
                        <div className="form-text">
                            Contoh: 0.5 artinya boleh lebih 0.5 kg saat penimbangan.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabFinance;